import type { BarSvodka, VidOzhidaniya } from './api';

/** Адрес точной выборки очереди из шапки: та же вкладка, филиал шапки и вид ожидания, что считает бар. */
export function adresOcheredi(filial: number | null, vid?: VidOzhidaniya | null, obrashchenie?: number | null): string {
  const p = new URLSearchParams({ vkladka: 'aktivnye' });
  if (filial !== null) p.set('filial_id', String(filial));
  if (vid) p.set('vid_ozhidaniya', vid);
  if (obrashchenie) p.set('obrashchenie', String(obrashchenie));
  return `/obrashcheniya?${p}`;
}

/** Слово шапки из словаря, приехавшего с баром (§31.1). */
export function slovoBara(data: BarSvodka | undefined, kod: string): string {
  return data?.slova?.[kod] ?? kod;
}
